// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Skeleton } from "@/components/ui/skeleton";

/**
 * Indeterminate progress bar shown at the top of a page while data loads.
 * Thin, animated, stays visible until loading completes.
 */
export function PageProgressBar() {
  return (
    <div className="fixed inset-x-0 top-0 z-[60] h-0.5 overflow-hidden bg-primary/20">
      <div className="h-full w-1/3 animate-progress-bar bg-primary" />
    </div>
  );
}

/**
 * Skeleton placeholder for detail pages with tabs.
 * Shows a header skeleton + tab bar skeleton + content area skeleton.
 */
export function DetailPageSkeleton() {
  return (
    <div>
      {/* Subtitle bar */}
      <div className="flex items-center gap-2 px-4 py-2 border-b">
        <Skeleton className="h-5.5 w-16 rounded-sm border border-transparent" />
        <Skeleton className="h-5.5 w-24 rounded-sm border border-transparent" />
        <Skeleton className="h-5.5 w-20 rounded-sm border border-transparent" />
      </div>
      {/* Tab bar */}
      <div className="pl-5 pr-6 pt-6 pb-2">
        <div className="inline-flex h-9 items-center rounded-lg bg-muted p-[3px] gap-1">
          <Skeleton className="h-7 w-16 rounded-md bg-muted-foreground/10" />
          <Skeleton className="h-7 w-20 rounded-md bg-muted-foreground/10" />
          <Skeleton className="h-7 w-16 rounded-md bg-muted-foreground/10" />
          <Skeleton className="h-7 w-14 rounded-md bg-muted-foreground/10" />
        </div>
      </div>
      {/* Content */}
      <div className="space-y-4 px-6">
        <Skeleton className="h-10 w-full max-w-md" />
        <Skeleton className="h-10 w-full max-w-md" />
        <Skeleton className="h-10 w-full max-w-sm" />
      </div>
    </div>
  );
}

/**
 * Skeleton placeholder for tab content while its data loads.
 */
export function TabContentSkeleton() {
  return (
    <div className="space-y-4 p-6">
      <Skeleton className="h-10 w-full max-w-md" />
      <Skeleton className="h-10 w-full max-w-md" />
      <Skeleton className="h-10 w-full max-w-sm" />
      <Skeleton className="h-10 w-full max-w-lg" />
    </div>
  );
}
